const token = localStorage.getItem('token')

export const laodFoldersTree = function () {
  let url = 'http://localhost:5000/api/folder/treeview/99999999-9999-9999-9999-999999999999'
  return window.fetch(url, {
    method: 'GET',
    headers: {
      'authorization': 'Bearer ' + token
    }
  }).then(response => {
    return response.json()
  }).then(result => {
    return result
  })
}
export const loadChildrenFolders = function (id) {
  let url = `http://localhost:5000/api/folder/treeview/99999999-9999-9999-9999-999999999999/${id}`
  return window.fetch(url, {
    method: 'GET',
    headers: {
      'authorization': 'Bearer ' + token
    }
  }).then(response => {
    return response.json()
  }).then(result => {
    return result
  })
}



// WEBPACK FOOTER //
// ./src/api/treeviewApi.js